export default __webpack_public_path__ + "static/media/drawing-desk-1.32124a20.jpg";